import { createRouter, createWebHistory } from "vue-router";
import { Auth } from "aws-amplify";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { public: true },
    redirect: "/materials",
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import("../views/SignupView.vue"),
    meta: {
      title: "アカウント登録",
      public: true,
      isBack: true,
      isGnav: false,
    },
    redirect: "/login",
  },
  {
    path: "/confirm",
    name: "confirm",
    component: () => import("../views/SignupConfirmView.vue"),
    meta: { public: true, isBack: true, isGnav: false },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
    meta: {
      title: "ログイン",
      public: true,
      isBack: false,
      isGnav: true,
      gnavGroup: "user-detail",
    },
  },
  {
    path: "/password/forgot",
    name: "password-forgot",
    component: () => import("../views/PasswordForgotView.vue"),
    meta: { public: true, isBack: true, isGnav: false },
  },
  {
    path: "/password/reset",
    name: "password-reset",
    component: () => import("../views/PasswordResetView.vue"),
    meta: { public: true, isBack: true, isGnav: false },
  },
  {
    path: "/api-demo",
    name: "api-demo",
    component: () => import("../views/APIDemoView.vue"),
    meta: { public: true },
    props: { isBack: true, isGnav: false },
  },
  {
    path: "/scan",
    name: "scan",
    component: () => import("../views/ScanView.vue"),
    meta: {
      title: "スキャンする",
      public: true,
      isBack: false,
      isGnav: true,
      gnavGroup: "scan",
    },
  },
  {
    path: "/materials",
    name: "materials",
    component: () => import("../views/MaterialListView.vue"),
    meta: {
      title: "さがす",
      public: true,
      isBack: false,
      isGnav: true,
      gnavGroup: "materials",
    },
  },
  {
    path: "/materials/:id",
    name: "material-detail",
    component: () => import("../views/MaterialDetailView.vue"),
    meta: {
      title: "詳細",
      public: true,
      isBack: true,
      isGnav: true,
      gnavGroup: "materials",
    },
  },
  {
    path: "/materials/edit/:id",
    name: "material-edit",
    component: () => import("../views/MaterialEditView.vue"),
    meta: { isBack: true, isGnav: false },
  },
  {
    path: "/user/:id",
    name: "user-detail",
    component: () => import("../views/UserDetailView.vue"),
    meta: {
      title: "マイ材木",
      public: true,
      isBack: false,
      isGnav: true,
      gnavGroup: "user-detail",
    },
  },
  {
    path: "/user/edit",
    name: "user-edit",
    component: () => import("../views/UserEditView.vue"),
    meta: { isBack: true, isGnav: false },
  },
  {
    path: "/locations",
    name: "locations",
    component: () => import("../views/LocationListsView.vue"),
    meta: { isBack: false, isGnav: true, gnavGroup: "user-detail" },
  },
  {
    path: "/locations/add",
    name: "location-add",
    component: () => import("../views/LocationEditView.vue"),
    meta: { isBack: true, isGnav: false },
  },
  {
    path: "/locations/edit/:id",
    name: "location-edit",
    component: () => import("../views/LocationEditView.vue"),
    meta: { isBack: true, isGnav: false },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  //set title when static title is set
  const title = to.meta.title ? `EMARF scan | ${to.meta.title} ` : `EMARF scan`;

  document.title = title;

  Auth.currentAuthenticatedUser()
    .then(() => {
      next();
    })
    .catch(() => {
      if (to.matched.some((record) => !record.meta.public)) {
        next({
          path: "/login",
          query: { redirect: to.fullPath },
        });
      } else {
        next();
      }
    });
});

export default router;
